import { useState } from "react";
import AuthInputs from "./components/AuthInputs";
import CheckboxRegular from "./components/CheckboxRegular";
import CheckboxRegularPrivacy from "./components/CheckboxRegularPrivacy";
import CheckboxRegularTerms from "./components/CheckboxRegularTerms";
import BrownSubmit from "../../buttons/BrownSubmit";
import {
  signupValidation,
  invalidPasswordMessage,
} from "../../../services/validation/authValidation";
import { useRouter } from "next/router";
// import { clientCookieSet } from "../../../services/cookies";
import { login, signup } from "../../../services/cms/auth";
import passwordValidator from "password-validator";
import ReCAPTCHA from "react-google-recaptcha";
import MailIcon from "../../icons/auth_inputs/mail.svg";
import LockIcon from "../../icons/auth_inputs/lock.svg";
import PersonIcon from "../../icons/auth_inputs/person.svg";
import PhoneIcon from "../../icons/auth_inputs/phone.svg";



// const SignupForm = ({ setError, setVisible }) => {
const SignupForm = ({ setError, setVisible }) => {
  const [recaptcha, setRecaptcha] = useState("");
  function onChange(value) {
    setRecaptcha(value);
  }
  //console.log(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, "sitekey");
  //redux learning only ^

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [password1, setPassword1] = useState();
  const [password2, setPassword2] = useState();
  const [privacy, setPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
  const [newsletter, setNewsletter] = useState(false);

  const router = useRouter();

  const schema = new passwordValidator();
  const schemaEmail = new passwordValidator();
  const schemaPhone = new passwordValidator();

  schema
    .is()
    .min(8)
    .is()
    .max(100)
    .has()
    .uppercase() // Must have uppercase letters
    .has()
    .lowercase() // Must have lowercase letters
    .has()
    .digits(1)
    .has()
    .symbols(1, ["!", "@", "#", "$", "%", "^", "&", "*"]) // Must have at least 2 digits
    .has()
    .not()
    .spaces();

  schemaEmail.has(["@"]);
  // .has(".");
  // .symbols(1, ["@"]);

  schemaPhone.has().digits(10);

  const displayInvalidPasswordErrorMessage = (array) => {
    return (
      <ul>
        {array.map((mess, index) => {
          return <li key={index}>{mess}</li>;
        })}
      </ul>
    );
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();

    const fullData = {
      first_name: firstName,
      last_name: lastName,
      username: email.toLowerCase(),
      email: email.toLowerCase(),
      phone: phone,
      password1: password1,
      password2: password2,
      newsletter: newsletter,
      privacy: privacy,
      terms: terms,
      recaptcha: recaptcha,
      password: password1
    };
    const validatedPassword = schema.validate(password1, { list: true });
    const validatedEmail = schemaEmail.validate(email, { list: true });
    const validatedPhone = schemaPhone.validate(phone, { list: true });

    if (
      validatedPassword.length === 0 &&
      validatedEmail.length === 0 &&
      validatedPhone.length === 0
    ) {
      const isValid = signupValidation(fullData);
      if (isValid.error) {
        setError(isValid.error);
        setVisible(true);
      } else if (isValid.success && recaptcha) {
        const response = await signup(fullData);
        if (response?.status === 201) {
          
          login(fullData);
          router.push("/onboarding/profile");
          // TODO: create a json of error codes
        } else {
          try {
            const errorMessage = await response.json();
            setError(errorMessage.status_message);
            setVisible(true);
          } catch (err) {
            console.log(err);
            setError(
              "Oops, something went wrong, and we're not sure what. Please reach out to info@thebohomarket.com",
            );
            setVisible(true);
          }
        }
      }
    } else if (
      validatedPassword.length > 0 ||
      validatedEmail.length > 0 ||
      validatedPhone.length > 0 ||
      !recaptcha
    ) {
      if (validatedPassword.length > 0) {
        const passwordErrorList = invalidPasswordMessage(validatedPassword);
        setError(displayInvalidPasswordErrorMessage(passwordErrorList));
        setVisible(true);
      }
      if (validatedEmail.length > 0) {
        setError("Please provide a valid email.");
        setVisible(true);
      }
      if (validatedPhone.length > 0) {
        setError(
          "Please provide your phone number in the following format: 1231231234.",
        );
        setVisible(true);
      }
      if (!recaptcha) {
        setError("Please fill out the recaptcha to proceed");
      }
    }
  };

  return (
    <form className="signup-form" noValidate onSubmit={(e) => onSubmitForm(e)}>
      {/* TODO noValidate temp measure, figure out why form isn't working */}
      <div className="signup_Format">
      <div>
      <AuthInputs
        label="First Name"
        value={firstName}
        setValue={setFirstName}
        type="text"
        imageAlt="person icon"
        imageURL={PersonIcon}
        htmlFor="first_name"
        placeholder="First name"
      />
      <AuthInputs
        label="Last Name"
        value={lastName}
        setValue={setLastName}
        type="text"
        imageAlt="person icon"
        imageURL={PersonIcon}
        htmlFor="last_name"
        placeholder="Last name"
      />
      <AuthInputs
        label="Phone Number"
        value={phone}
        setValue={setPhone}
        type="tel"
        imageAlt="phone icon"
        imageURL={PhoneIcon}
        htmlFor="phone"
        placeholder="1231231234"
      />
      <AuthInputs
        label="Email"
        value={email}
        setValue={setEmail}
        type="text"
        imageAlt="mail icon"
        imageURL={MailIcon}
        htmlFor="email"
        placeholder="Email"
      />
</div>
<div>
      <p style={{ marginBottom: "30px", display: "block", lineHeight: "16px", }}>
        Password must:
        <ul>
          <li>have minimum 8 characters</li>
          <li>have maximum 100 characters</li>
          <li>not have any spaces</li>
          <li>include at least 1 uppercase letter</li>
          <li>include at least 1 lowercase letter</li>
          <li>include at least 1 number</li>
          <li>include at least one of the following: ! @ # % ^ &amp; *</li>
        </ul>
      </p>
      <AuthInputs
        label="Password"
        value={password1}
        setValue={setPassword1}
        type="password"
        imageAlt="lock icon"
        imageURL={LockIcon}
        htmlFor="password1"
        placeholder="Password"
      />
      <AuthInputs
        label="Confirm Password"
        value={password2}
        setValue={setPassword2}
        type="password"
        imageAlt="lock icon"
        imageURL={LockIcon}
        htmlFor="password2"
        placeholder="Confirm Password"
      />
    </div>
  </div>
  <div className="signup-form-bottom">
      <CheckboxRegularPrivacy
        htmlFor="privacy"
        value={privacy}
        setValue={setPrivacy}
        link="/privacy"
      />

      <CheckboxRegularTerms
        link="/terms"
        htmlFor="terms"
        value={terms}
        setValue={setTerms}
      />

      <CheckboxRegular
        value={newsletter}
        setValue={setNewsletter}
        content="Send me the latest news and upcoming events"
      />
      </div>
      <div style={{textAlign: "center"}}>
      <div style={{ margin: "24px auto 24px auto",  display: "flex", flexDirection: "column", width: "20%"}}>
        <ReCAPTCHA
          sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
          onChange={onChange}
        />
      </div>
      
      <BrownSubmit
        paddingUpDown={20}
        paddingLeftRight={158}
        type="submit"
        content="Create Account"
        onSubmit={onSubmitForm}
      />
      </div>
    </form>
  );
};

export default SignupForm;
